var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDesktopDevice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#323232",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M8.587 2.667H23.4c4.747 0 5.933 1.186 5.933 5.92v8.44c0 4.746-1.186 5.92-5.92 5.92H8.586c-4.733.013-5.92-1.174-5.92-5.907V8.587c0-4.734 1.187-5.92 5.92-5.92M16 22.96v6.373M2.667 17.333h26.666M10 29.333h12"
})));
export default SvgDesktopDevice;